<div
  class="bg-black relative border-b-4 border-solid border-[#ff4d06] drop-shadow-lg w-full px-4 lg3:px-8 flex flex-col justify-stretch !h-[90px]  lg3:!h-[80px] items-center lg3:pt-3"
  style="background-color: black;"
>
  <div class="flex flex-row w-full justify-between !pr-0 ">
    <a [routerLink]="['/']" [ariaLabel]="'home'">
      <div class=" " style="position: relative;">
        <video
          src="../../../assets/branding/fortnite3.webm"
          class="!h-[56px] lg3:h-[66px]"
          *ngIf="showVideo"
          style="
            position: absolute;
            filter: brightness(1.8);
            object-fit: cover;
            object-position: top;
            margin-top: 0px;
            width: 100%;
          "
          [autoplay]="showVideo"
          muted
          loop
          playsinline
          webkit-playsinline 
          disablePictureInPicture
        ></video>

        <img
          src="../../../assets/branding/softnet-logo-2.webp"
          class="w-full !h-[56px] pr-4"
          alt="softnet computers logo"
          style="
             
            mix-blend-mode: multiply; -webkit-mix-blend-mode: multiply;
            background-color: black;
            object-fit: contain;
          "
        />
      </div>
    </a>

    <!-- <a style="position: absolute; left: 340px; top: 0px;" class="hidden md:block" href="https://www.vote.bestweb.lk/site/softnetcomputers_lk"
        ><img
          src="https://www.bw2024.lk/vote4us.png"
          alt="logo"
          width="150"
          height="150"
          class="drop-shadow-xl"
      /></a> -->

    <!-- <div class="w-full grow hidden lg3:block"></div> -->

    <div class="flex flex-row shrink-0 items-center justify-center gap-2">
      <!-- <span class="w-[150px] h-[150px] relative"> -->
        <!-- <a
          style="position: absolute; right: 600px; top: -5px;"
          class="hidden md:block"
          href="https://www.vote.bestweb.lk/site/softnetcomputers_lk"
          ><img
            src="https://www.bw2024.lk/vote4us.png"
            alt="logo"
            width="150"
            height="150"
            class="drop-shadow-xl"
        /></a> -->

      <!-- </span> -->

      <small
        (click)="openSearch()"
        class="text-white italic cursor-text hidden lg3:block"
        >search here</small
      >
      <button
        (click)="openSearch()"
        aria-label="search through all the categoriesg"
        matTooltip="Site wide search"
        class="border border-white hover:border-[#ff4d06] text-white h-[32px] w-[32px] rounded-full text-sm gap-2 p-[5px]"
      >
        <div id="logo"
          style="
            background-image: url('../../../assets/graphics/search_24dp_FILL0_wght300_GRAD0_opsz24.svg');
            background-repeat: no-repeat;
            background-size: contain;
            background-position: center;
          "
          class="w-full h-full"
        ></div>
      </button>

      <button
        aria-label="Help menu"
        matTooltip="Help menu"
        [matMenuTriggerFor]="menu"
        class="border border-white hover:border-[#ff4d06] text-white h-[32px] w-[32px] rounded-full text-sm gap-2"
      >
        ?
      </button>
      <button
        class="h-[32px] w-[32px] block lg3:hidden"
        aria-label="website menu"
        (click)="navopen()"
        mat-icon-button
      >
        <img
          src="../../../assets/graphics/apps_FILL0_wght400_GRAD0_opsz24.svg"
          alt="website menu"
          style="min-height: 32px; min-width: 32px; width: 32px; height: 32px;"
        />
      </button>

      <div class="text-center flex-col text-white hidden lg3:flex">
        <small>Hotline</small>
        <a
          href="tel:+94772553478"
          target="_blank"
          [ariaLabel]="'call now'"
          class="text-white text-xl pb-0 mb-0 w-[200px] font-black"
          style="z-index: 100; font-family: Tahoma, sans-serif;"
          ><span class="text-[#ff4d06]">077 </span>255 3478</a
        >
      </div>

      <div
        class="text-center flex-col text-white hidden lg3:flex cursor-pointer"
        (click)="download()"
      >
        <small>Total Quotation</small>
        <span
          class="text-white text-xl font-black pb-0 mb-0 w-[200px]"
          style="z-index: 100; font-family: Tahoma, sans-serif;"
          ><span class="text-[#ff4d06]">Rs.</span>{{ total }}</span
        >
      </div>
      <!-- <a
      style="position: absolute; right: 0px; top: 80px;  "
      class="hidden md:block"
      href="https://www.vote.bestweb.lk/site/softnetcomputers_lk"
      ><img
        src="https://www.bw2024.lk/vote4us.png"
        alt="logo"
        width="150"
        height="150"
        class="drop-shadow-xl"
    /></a> -->

    </div>
  </div>
  <div class="flex w-full block lg3:hidden">
    <div class="text-center flex flex-col text-white w-1/2">
      <a
        href="tel:+94772553478"
        target="_blank"
        [ariaLabel]="'call now'"
        class="text-white text-xl font-black pb-0 mb-0 w-[200px]"
        style="z-index: 100; font-family: Tahoma, sans-serif;"
        ><span class="text-[#ff4d06]">077 </span>255 3478</a
      >
    </div>

    <div
      class="text-center flex flex-col text-white w-1/2 cursor-pointer"
      (click)="download()"
    >
      <span
        class="text-white text-xl font-black pb-0 mb-0 w-full"
        style="z-index: 100; font-family: Tahoma, sans-serif;"
        ><span class="text-[#ff4d06]">Rs.</span>{{ total }}</span
      >
    </div>
  </div>
</div>

<mat-menu #menu="matMenu">
  <span class="font-semibold pl-4 pt-4">HELP</span>
  <button [routerLink]="['/help/how-to-use-filters']" mat-menu-item>
    Product Filters
  </button>
  <button [routerLink]="['/help/quotation-generation']" mat-menu-item>
    Quotation Generation
  </button>
  <hr class="mb-1" />
  <span class="font-semibold pl-4 pt-4">LEGAL</span>
  <button routerLink="/privacy-policy" mat-menu-item>Privacy Policy</button>
  <button routerLink="/cookie-policy" mat-menu-item>Cookie Policy</button>
  <button routerLink="/terms-and-conditions" mat-menu-item>
    Terms and Conditions
  </button>
</mat-menu>
